<template>
  <div class="card">
    <HeaderO title="销售计划详情"></HeaderO>
    <div class="card-header">
      <van-row class="info">
          <van-col span="12">
            <span class="info-title" >华北化工：</span>
            <span class="info-value"></span>
          </van-col>
          <van-col span="12">
            <span class="info-title">产品大类：</span>
            <span class="info-value">{{Datadetail.topCateName}}</span>
          </van-col>
        </van-row>
    </div>
    <div class="delivery">
      <div class="card-header">
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">物料编号</span>
            <span>:</span>
            <span class="info-value">{{Datadetail.materialCode }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">用途</span>
            <span>:</span>
            <span class="info-value">{{Datadetail.usageName }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">产品名称</span>
            <span>:</span>
            <span class="info-value">{{Datadetail.commodityName}}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">生产企业</span>
            <span>:</span>
            <span class="info-value">{{Datadetail.manufacturer }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">规格牌号</span>
            <span>:</span>
            <span class="info-value"> {{ Datadetail.spec }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">产品等级</span>
            <span>:</span>
            <span class="info-value">{{Datadetail.grade }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">月计划量</span>
            <span>:</span>
            <span class="info-value"> {{ Datadetail.finalMonthSalesQuantity }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">半月执行量</span>
            <span>:</span>
            <span class="info-value"> {{Datadetail.halfMonthUseQuantity }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">月执行量</span>
            <span>:</span>
            <span class="info-value">{{Datadetail.monthUseQuantity }}</span>
          </van-col>
        </van-row>
        <van-row class="info">
          <van-col span="12">
            <span class="info-title">半月执行率</span>
            <span>:</span>
            <span class="info-value"> {{  }}</span>
          </van-col>
          <van-col span="12">
            <span class="info-title">月执行率</span>
            <span>:</span>
            <span class="info-value">{{ }}</span>
          </van-col>
        </van-row>
        <van-row class="info" type="flex" justify="center">
            <van-col span="6" ></van-col>
            <van-col span="6" >
                <span>上旬</span>
            </van-col>
            <van-col span="6">
                <span>中旬</span>
            </van-col>
            <van-col span="6">
                <span>下旬</span>
            </van-col>
        </van-row>
        <van-row class="info">
            <van-col span="6" >
                <span>时  间</span>
            </van-col>
            <van-col span="6" >
                <span>1-10</span>
            </van-col>
            <van-col span="6" >
                <span>10-20</span>
            </van-col>
            <van-col span="6" >
                <span>20-30</span>
            </van-col>
        </van-row>
        <van-row class="info">
            <span >计划量</span>
        </van-row>
        <van-row class="info">
            <span >执行量</span>
        </van-row>
        <van-row class="info">
            <span >执行率</span>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderO from "@/components/HeaderO.vue";
import salePlanApi from "@/request/salePlanApi";
export default {
  name: "QualificationCard",
  props: {
    complaint: Object
  },
  components: {
      HeaderO,
  },
  data() {
    return {
       Datadetail: {},
    };
  },
  mounted() {
    this.getPlanMonthSalesAllDetail();
  },
  computed: {},
  methods: {
    async getPlanMonthSalesAllDetail() {
      let params = {id: this.$route.query.id,};
      salePlanApi.getPlanMonthSalesAllDetail(params).then((res) => {
        if (res.returnCode == "0") {
          this.Datadetail = res.result;
        //   let tempList = res.result.dataList;
        //   this.dataList = this.dataList.concat(tempList);
        //   this.hasNextPage = res.result.hasNextPage;
        //   if (this.hasNextPage) {
        //     this.$refs.wrapper.forceUpdate(true);
        //   } else {
        //     this.$refs.wrapper.forceUpdate(false);
        //   }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';
/* .font30 {
  font-size: 30px;
}
.delivery-list >>> .van-col {
    line-height: 50px;
} */

.card {
  margin-top: 10px;
  background: #ffffff;
  padding: 12px 24px;
  font-size: 26px;
  border-radius: 20px;
  .card-header {
    // margin-bottom: 20px;
  }

  .card-header, .card-total, .card-info {
    padding: 12px 0;
  }

  .card-info, .card-total {
    color: #666666;
  }

  .info {
    line-height: 61px;

    .info-title {
      display: inline-block;
      min-width: 80px;
      text-align: justify;
      text-align-last: justify;
    }

    .info-value {
      margin-left: 16px;
    }

    .status {
      padding: 8px 12px;
      border: 1px solid black;
      border-radius: 10px;
    }
  }

  .color-red {
    color: #E12020;
  }

  .large {
    font-size: 36px;
  }

  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;

    .btn {
      min-width: 200px;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>